import { createContext, useEffect, useReducer } from "react";
import { useParams } from "react-router-dom";

import { fetchFtmApprovalProcessSteps, fetchFtmIdentificationDetails } from "./service";
import Loader from "../../components/loading";
import Reducer from "./reducer";
import { initialState } from "./initialState";

const Context = createContext();

const Provider = ({ children }) => {
    const { ftm_id } = useParams();
    const [ state, dispatch ] = useReducer(Reducer, initialState);

    useEffect(() => {
        const fetchData = async () => {
            try {
                dispatch({
                    type: "LOADING"
                });

                const [stepsRes, idDetailsRes] = await Promise.all([
                    fetchFtmApprovalProcessSteps(),
                    fetchFtmIdentificationDetails(ftm_id)
                ]);

                if (stepsRes.status === "Success") {
                    dispatch({
                        type: "SET_APPROVAL_PROCESS_STEPS",
                        approvalProcessSteps: stepsRes?.data
                    });
                }
                if (idDetailsRes.status === "Success") {
                    dispatch({
                        type: "SET_IDENTIFICATION_DETAILS",
                        identificationDetails: idDetailsRes?.ftm
                    });
                }
            } catch (error) {
                console.error("Error fetching approval process data:", error);
            } finally {
                dispatch({
                    type: "LOADED"
                });
            }
        };

        fetchData();
    }, [ftm_id, state.refreshCount]);

    if (state.loading) {
        return <Loader/>;
    }

    return (
        <Context.Provider value={{...state, dispatch}}>
            {children}
        </Context.Provider>
    );
};

export { Context, Provider };